module.exports = __webpack_public_path__ + "static/media/face-1.e2e3e228.jpg";